import { Tooltip } from 'antd'
import { FC } from 'react'
import formatDuration from '../../../../../helpers/date-time/format-duration'
import {
    getShipmentDisplayCalculated,
    isShipmentCalculatedOnActual,
} from '../../../../../helpers/entities/shipment/get-shipment-display-calculated'
import Shipment from '../../../../../types/api/shipment'
import ShipmentCalculatedValue from '../../../../../components/shipment-calculated-value/shipment-calculated-value'

interface ShipmentTimeCellProps {
    shipment?: Shipment | null
}

const ShipmentTimeCell: FC<ShipmentTimeCellProps> = ({ shipment }) => {
    const calculated = getShipmentDisplayCalculated(shipment)
    const printingTime = calculated?.printingTime ?? 0
    const finishingTime = calculated?.finishingTime ?? 0

    return (
        <ShipmentCalculatedValue isActual={isShipmentCalculatedOnActual(shipment)}>
            <Tooltip
                title={
                    <>
                        Время печати — {formatDuration(printingTime)}
                        <br />
                        Время отделки — {formatDuration(finishingTime)}
                    </>
                }
            >
                <span>{formatDuration(calculated?.commonTime ?? 0)}</span>
            </Tooltip>
        </ShipmentCalculatedValue>
    )
}

export default ShipmentTimeCell
